import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import ShowMoreIcon from '/static/icons/arrows/show-more.svg';

const Wrapper = styled.div`
    margin-bottom: 75px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.colors.blue};
    margin-left: ${props => (props.rightIcon ? 'auto' : '0px')};
    &:hover {
        color: ${props => props.theme.colors.black};
        cursor: pointer;
    }
    p {
        margin: 0px;
    }
    svg {
        margin-right: 5px;
    }
`;

const ShowMoreButton = ({ handleClick }) => (
    <Wrapper onClick={ handleClick }>
        <ShowMoreIcon />
        <p>Show more</p>
    </Wrapper>
);

export default ShowMoreButton;